/**
 * Density scale — one shared row/button/input/badge height rhythm.
 *
 * Mirrors the design-system tokens in `design-system/tokens.css`:
 *   --row-h: 28px      (h-7)   · table/quote rows, icon-buttons, actions
 *   --header-h: 40px   (h-10)  · top app bar
 *   --tabbar-h: 32px   (h-8)   · chart header / footer tab bar
 *   --action-h: 24px   (h-6)   · legacy compact action; unified up to the row token
 *   --pill-h: 20px     (h-5)   · timeframe pill / account trigger
 *
 * The terminal is meant to breathe on a 28px row grid with 11px workhorse text.
 * Compose these constants instead of re-guessing raw height classes so every
 * row, button, input and badge snaps to the same rhythm.
 *
 * NOTE: Mobile touch targets (`min-h-11`, 44px) are intentionally larger for
 * accessibility and are NOT part of this scale — never shrink those.
 */
export const DENSITY = {
  /** h-7 (28px) — the canonical row / control height. */
  ROW_H: "h-7",
  /** h-7 w-7 (28px) — square icon-button on the row grid. */
  ICON_BTN: "h-7 w-7",
  /** h-8 (32px) — toolbar / tab-bar height. */
  TOOLBAR_H: "h-8",
  /** h-4 (16px) — inline badge / pill inside a row. */
  BADGE_H: "h-4",
  /** text-[11px] — 11px workhorse data/label text. */
  TEXT_WORKHORSE: "text-[11px]",
} as const;

export type DensityToken = keyof typeof DENSITY;
